// import Helmet from "react-helmet"
import { window } from 'browser-monads';
import he from "he";
import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import ReactDOM from 'react-dom';
// import BANNER from "../../components/banner";
import {default as BannerComponent} from "../../components/banner";
import BookmarkButton from "../../components/bookmark-button";
import EditPostButton from '../../components/edit-post-button';
import Loading from "../../components/loading";
import PostsTitleWidget from "../../components/posts-title-widget";
// import Layout from "../../components/layout"
// import SEO from "../../components/seo";
import {default as SeoComponent} from "../../components/seo";
// import { document } from 'browser-monads';
// import srcImgFeatured from '../../fonts/logo.svg'
// import styled from 'styled-components'
import SharePanel from "../../components/share";
import { NewmagCategoryHeadTitleWidget } from "../../components/widget-overwrite/newmag-category-head-title";
import { replaceHtmlElementWithComponent } from "../../components/widget-overwrite/utils";
import { Link } from "gatsby";
import { UrlsUtils } from '../../utils/UrlsUtils';




// export const themes = {
//   light: {
//     foreground: 'black',
//     background: 'white',
//   },
//   dark: {
//     foreground: 'white',
//     background: 'rgb(47, 47, 47)',
//   },
// };

// export const ThemeContext = React.createContext({
//   theme: themes.dark,
//   toggleTheme: () => {},
// });


const SinglePage = props => {

  const thisComponentRef = useRef();

  const [newcontentset, setContentHtml] = useState("");

  const {
    pageContext: {
      id,
      postId,
      vertical,
      kind,
      title,
      content,
      featuredImage,
      pageId
    },
  } = props

  // const ImgFeatured = styled.img`
  //     width: 100%;
  //     height: auto;`

  var pathname = props.location.pathname || '';

  // var pathnameCleaned = pathname.replaceAll('/', '');
  var pathnameCleaned = pathname.replace(/\//g, '');


  var hide_header = pathname==="/"? "none":"";
  var header_height = pathname==="/"? "0px":"";
  // var display_sidebar_logo = pathname==="/"? "none":"";
  // var display_page_logo = pathname==="/"? "":"none";

  var title_clean = he.decode(title);
  var excerpt_clean= "";//he.decode(excerpt);

  // var regStr = 'http[s]*://(?!cdn)[a-z0-9A-Z.]*'+process.env.GATSBY_WPHOST+'/';
  // var reg = new RegExp(regStr,'g');

  // var regStrContent = 'http[s]*://(?!cdn)[a-z0-9A-Z.]*'+process.env.GATSBY_WPHOST+'/wp-content/';
  // var regContent = new RegExp(regStrContent,'g');

  // var regBannerStr = '<banner>.*</banner>';
  // var regBanner = new RegExp(regStr);

  var newcontent = UrlsUtils.ensure_wp_content(content);
  newcontent = UrlsUtils.ensure_wp_admin_url(newcontent);



  //newcontent = newcontent.replace(regBanner, '');

  //var newcontent = newcontent.replace("banner", 'BANNER');

  function fire_slider() {
    console.log('fire_slider');
    try {
      window.jQuery('.group_bandi').slick({
          autoplay: true,
          infinite: true,
          pauseOnFocus: true,
          variableWidth: true,
          autoplaySpeed: 8000,
          arrows: true,
          adaptiveHeight: true,
          slidesToShow: 3,
          responsive: [
            {
              breakpoint: 778,
              settings: {
                arrows: true,
                slidesToShow: 4
              }
            },
            {
              breakpoint: 480,
              settings: {
                arrows: false,
                slidesToShow: 2
              }
            }
          ],
          dots: true,
        });
    } catch (err) {}

    try {
      window.jQuery('.group_trendtopic_big_post_single_articles').slick({
        autoplay: true,
        infinite: true,
        pauseOnFocus: true,
        autoplaySpeed: 8000,
        arrows: true,
        slidesToShow: 2,
        responsive: [
        {
        breakpoint: 1024,
        settings: {
        arrows: true,
        slidesToShow: 1
        }
        },
        {
        breakpoint: 480,
        settings: {
        arrows: false,
        slidesToShow: 1
        }
        }
        ],
        dots: true,
      });
    } catch (err) {}



    try {
      window.jQuery(".group_agenda").slick({
        autoplay: true,
        infinite: true,
        pauseOnFocus: true,
        variableWidth: true,
        autoplaySpeed: 8000,
        arrows: true,
        adaptiveHeight: true,
        slidesToShow: 3,
        responsive: [
          {
            breakpoint: 778,
            settings: {
              arrows: true,
              slidesToShow: 4
            }
          },
          {
            breakpoint: 480,
            settings: {
              arrows: false,
              slidesToShow: 2
            }
          }
        ],
        dots: true,
      });
    } catch (err) {}


    try {
      window.jQuery(".responsive_row_youtube").slick({
        infinite: true,
        autoplay: true,
        pauseOnFocus: true,
        autoplaySpeed: 8000,
        slidesToShow: 2,
        slidesToScroll: 1,
        centerMode: true,
        dots: true,
        arrows: true,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              arrows: true,
            },
          },
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              arrows: false,
            },
          },
          {
            breakpoint: 769,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: false,
            },
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: false,
            },
          },
        ],
      })
    } catch (err) {}

  }

  useLayoutEffect(() => {
    //alert(window.jQuery);

    setTimeout(() => {
      // var extractscript = /<script>(.+)<\/script>/gi.exec(newcontent);
      // console.log("newcontent", newcontent);
      // console.log("extractscript newcontent", extractscript);
      // newcontent = newcontent.replace(extractscript[0], "");
      // window.eval(extractscript[0]);
      // debugger;

      setContentHtml(newcontent);

      // var portalId = newcontent.substring(
      //     newcontent.lastIndexOf('portalId: \"') + 1,
      //     newcontent.lastIndexOf('\",')
      // );
      // var formId = newcontent.substring(
      //   ù  newcontent.lastIndexOf(":") + 1,
      //     newcontent.lastIndexOf(";")
      // );

      try {
        // var portalId = newcontent
        //   .split('hbspt.forms.create({\n\tportalId: "')
        //   .pop()
        //   .split('",')[0];
        // var formId = newcontent.split('formId: \"').pop().split('\"\n})')[0]
        var portalId = newcontent.split('portalId: "').pop().split('"')[0];
        var formId = newcontent.split('formId: "').pop().split('"')[0];

        if (
          window.hbspt &&
          !isNaN(portalId) &&
          !isNaN(parseFloat(portalId)) &&
          formId
        ) {
          setTimeout(function () {
            window.hbspt.forms.create({
              portalId: portalId,
              formId: formId,
            });
          }, 1000);
        }
      } catch (error) {
        console.log('hbspt error', error);
      }

      try {
        fire_slider();
      } catch (error) {
        console.error(error);
      }

    }, 300);

    return () => {
      //unload listener...
      // didunmount
    };
  }, [newcontent]);


  useEffect(() => {
    if (title === "Advisory Board" && id === "cG9zdDoxMDE4MTc=") {
      var primaryDiv = thisComponentRef.current.querySelectorAll(
        ".entry-page-content"
      )
      primaryDiv.forEach((el) => {
        el.classList.add("primary-advisory-board")
        var panelLayout = el.querySelector(
          ".panel-layout"
        )
        if (panelLayout) {
          var div = document.createElement("div");
          div.id = "sfondo_landing"
          div.innerHTML = '<div class="div_logo"><div class="logo_landing_titolo" alt="logo"></div></div>';
          if (!panelLayout.querySelector(".div_logo")) panelLayout.prepend(div)
        }
      })
    }

    // if (title === "Convergent Marketing")


    try {
      var page_headers = thisComponentRef.current.querySelectorAll(
        '*[widget="newmag-category-head-title"]'
      );
      if (page_headers.length) {
        // debugger;
        page_headers.forEach((ph) => {
          // NewmagCategoryHeadTitleWidget

          let title = ph.getAttribute("data-widget_title");
          let title_color = ph.getAttribute("data-widget_title_color");
          let subtitle = ph.getAttribute("data-widget_subtitle");
          let image = ph.getAttribute("data-widget_image");
          let comp = React.createElement(
            NewmagCategoryHeadTitleWidget,
            {
              title: title,
              title_color: title_color,
              subtitle: subtitle,
              image: image,
            }
            // [props],
            // [...children]
          );
          try {
            replaceHtmlElementWithComponent(
              ph,
              comp,
              () => {},
              "div",
              "",
              "mag_category_head_spacer replaced-widget"
              // (el) => {
              //   el.classList = 'mag_category_head_spacer replaced-widget';
              // }
            );
          } catch (error) {
            console.error(error);
            console.error(error);
          }
        });
      }
    } catch (error) {
      console.error(error);
    }

    var posts_category;
    try {
      posts_category = thisComponentRef.current.querySelectorAll(
        'a > div.mag_customnumcat_posts_category');
      posts_category.forEach(post_category => {
        let textContent = post_category.textContent;
        if (textContent) {
          let text = textContent.toLowerCase().replace(/\s/g, '');
          let _a = post_category.parentElement;

          if (_a.href.includes('/category/unstoppable-women'))
            _a.href = '/unstoppablewomen'
          else if ((_a.href || '').includes("/category/"))
            _a.href = _a.href.replace(/\/$/,"-" + text);
        }
      })
    } catch (error) {
      console.error(error);
    }

    try {
      posts_category = thisComponentRef.current.querySelectorAll(
        '.mag_big_post_single_homecategory_category, .mag_big_post_single_category');
      posts_category.forEach(post_category => {
        let textContent = post_category.textContent;
        if (textContent) {
          let text = textContent.toLowerCase().replace(/\s/g, '');
          let _a = post_category.parentElement.parentElement;

          if (_a && _a.href && _a.href.includes('/category/unstoppable-women'))
            _a.href = '/unstoppablewomen'
          else if ((_a.href || '').includes("/category/"))
            _a.href = _a.href.replace(/\/$/,"-" + text);
        }
      })
    } catch (error) {
      console.error(error);
    }

    // Add class to revert wrong order of posts
    var group_big_post_single_homecategories;
    try {
      group_big_post_single_homecategories = thisComponentRef.current.querySelectorAll(
        '.group_big_post_single_homecategory'
      )
      group_big_post_single_homecategories.forEach(
        group => {
          if(group.children && group.children[0] && group.children[0].classList.contains('left_homecategory')) {
            group.classList.add("group_big_post_single_homecategory_to_revert");
          }
        }
      );
    } catch (error) {
      console.error(error);
    }

    // Set trend topic background image
    var category_from_urls;
    var tranding_topic;
    var category_from_url;
    try {
      tranding_topic = thisComponentRef.current.querySelectorAll(
        '.tranding_topic'
      )
      // Better to extract the url from a category link
      category_from_urls = thisComponentRef.current.querySelectorAll(
        '.trendtopic_right_cointainer > .group_big_post_single > .a_black');
      if (category_from_urls.length) {
        category_from_url = category_from_urls[0].href;
        // Check if it's the category div
        if (category_from_urls[0].children[0].className === 'mag_trendtopic_posts_single_category') {
          if (category_from_url.endsWith('/')) category_from_url = category_from_url.split('/')[category_from_url.split('/').length -2];
          else category_from_url = category_from_url.split('/')[category_from_url.split('/').length -1];

          if (category_from_url === 'unstoppable-women') category_from_url = 'unstoppablewomen'
          else category_from_url = category_from_url.split('-')[0];

          tranding_topic[0].style.backgroundImage="url(/img/" + category_from_url.toLowerCase() + "@2x.jpg)";
        }
      }
    } catch (error) {
      console.error(error);
    }

    // Add play img if post is video
    var post_div_videos_opacity;
    var post_div_videos
    try {
      post_div_videos_opacity = thisComponentRef.current.querySelectorAll(
        ".map_posts_single_imgdiv_homecategory,.map_customnumcat_posts_imgdiv,.map_head_posts_imgdiv,.map_posts_single_imgdiv"
      )
      post_div_videos_opacity.forEach((div) => {
        if (
          div.style.background &&
          div.style.background ===
            "linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.7))"
        ) {
          div.style.display = 'none';
        }
      })

      post_div_videos = thisComponentRef.current.querySelectorAll(
        ".map_posts_single_imgdiv_homecategory_video,.map_customnumcat_posts_imgdiv_video,.map_head_posts_imgdiv_video,.map_posts_single_imgdiv_video"
      )
      post_div_videos.forEach(div => {
        div.classList.remove("map_posts_single_imgdiv_homecategory_video");
        div.classList.add("map_posts_single_imgdiv_homecategory_video_new");
        div.classList.remove("map_customnumcat_posts_imgdiv_video");
        div.classList.add("map_customnumcat_posts_imgdiv_video_new");
        div.classList.remove("map_head_posts_imgdiv_video");
        div.classList.add("map_head_posts_imgdiv_video_new");
        div.classList.remove("map_posts_single_imgdiv_video");
        div.classList.add("map_posts_single_imgdiv_video_new");

        div.style.margin = "0 auto";
        div.style.backgroundImage = "url('/img/circle_play_fill@2x.png')";
        div.style.backgroundSize = "cover";
        div.style.backgroundPosition = "center";
        div.style.backgroundRepeat = "no-repeat";
        div.style.zIndex = "1";
        div.style.position = "absolute";
        div.style.backgroundSize = "auto";
        div.style.top = "0";
        div.style.left = "0";
        div.style.height = "100%";
        div.style.width = "100%";
      })
    } catch (error) {
      console.log(error);
    }

    var div_categories;
    try {
      div_categories = thisComponentRef.current.querySelectorAll(
        ".right_customnumcat_posts > .group > .a_black"
      )
      div_categories.forEach((post_category) => {
        post_category.classList.add("a_black_category");
      })
    } catch (error) {
      console.error(error)
    }

    var big_links_widget
    try {
      big_links_widget = thisComponentRef.current.querySelectorAll(
        ".textwidget > p > a"
        // ".so-panel.widget.widget_text > .textwidget, .textwidget > p > a"
      )
      let comp;
      big_links_widget.forEach((big_title) => {
        if (big_title.tagName === 'A') {
          comp = React.createElement(PostsTitleWidget, {
            title: (big_title.textContent || "").replace(" test WP", ""),
            href: big_title.href,
          })
        } else {
          comp = React.createElement(PostsTitleWidget, {
            title: (big_title.textContent || "").replace(" test WP", ""),
          })
        }
        ReactDOM.render(comp, big_title.parentElement)

        big_title.classList.add("mag_big_post_single_right_head_title")
        big_title.style.fontWeight = "800"
      })
    } catch (error) {
      console.error(error)
    }

    // TODO: missing categories
    // var posts_category_title;
    // try {
    //   posts_category_title = thisComponentRef.current.querySelectorAll(
    //     'a > div.mag_six_posts_category');
    //   posts_category_title.forEach(post_category_title => {
    //     let _a = post_category_title.parentElement;
    //     if (!post_category_title.textContent && _a.href) {
    //       console.log('post_category_title', post_category_title, ' _a', _a, '_a.href', _a.href);
    //     }
    //   })
    // } catch (error) {
    //   console.error(error);
    // }

    // console.log(newcontent);
    // console.log(thisComponentRef);
    let bookmarks = [];
    let bookmarks_img = [];
    try {
      // bookmarks = thisComponentRef.current.querySelector('a[name="toggle_preferred"]')
      bookmarks = thisComponentRef.current.querySelectorAll('a[name="toggle_preferred"] > img.icon_prefered');
    } catch (error) {
      console.error(error);
    }

    try {
      bookmarks_img = thisComponentRef.current.querySelectorAll(
        'div.floatright > img.icon_prefered, ' +
        'div.floatright_homecategory > img.icon_prefered, ' +
        'div.floatleft > img.icon_prefered');
    } catch (error) {
      console.error(error);
    }

    if (bookmarks && (typeof bookmarks === typeof [] && bookmarks.length > 0)) {
      // console.log(bookmarks);
      // debugger;
      // console.log(bookmarks);
      bookmarks.forEach(el => {
        let onclick = undefined;
        try {
          let p = el.parentElement
          p.innerHTML = el.parentElement.innerHTML.replaceAll('\\"', '&quot;').replaceAll('=""', '').replaceAll('""', '');
          onclick = p.firstElementChild.getAttribute('onclick');
          if (!onclick) {
            throw new Error(el.outerHTML);
          }
          // console.log(onclick);
          let params;
          // eslint-disable-next-line no-eval
          params = eval(
            '[' + onclick.split(');')[0].replace('toggle_preferred(', '') + ']'
          );

          // console.log(params);

          let comp = React.createElement(
            BookmarkButton,
            {
              news_url: params[0],
              // news_title: params[1],
              // news_image: params[2],
              // news_author: params[3],
              // news_video: params[4],
              // news_is_media: params[5],
              // components_name_md5: params[0],
            },
            // [props],
            // [...children]
          );
          // debugger;
          ReactDOM.render(comp, p.parentElement);
        } catch (error) {
          console.error(onclick, error);
          console.error(onclick, error);
        }
      });

    }

    if (bookmarks_img && (typeof bookmarks_img === typeof [] && bookmarks_img.length > 0)) {
      // console.log(
      //   );
      //   debugger;
      //   console.log(bookmarks_img);
      bookmarks_img.forEach(el => {
        // }
        let onclick = undefined;
        try {
          let p = el.parentElement
          p.innerHTML = el.parentElement.innerHTML.replaceAll('\\"', '&quot;').replaceAll('=""', '').replaceAll('""', '');
          onclick = p.firstElementChild.getAttribute('onclick');
          if (!onclick) {
            throw new Error(el.outerHTML);
          }
          // console.log(onclick);
          let params;
          // eslint-disable-next-line no-eval
          params = eval(
            '[' + onclick.split(');')[0].replace('toggle_preferred(', '') + ']'
          );
          // console.log(params);

          let comp = React.createElement(
            BookmarkButton,
            {
              news_url: params[0],
              news_title: params[1],
              news_image: params[2],
              news_author: params[3],
              news_video: params[4],
              news_is_media: params[5],
              components_name_md5: params[0],
            },
            // [props],
            // [...children]
          );
          // debugger;
          ReactDOM.render(comp, p);

        } catch (error) {
          console.error(onclick, error);
          debugger;
          console.error(onclick, error);
        }
      });
    }

    return () => {
      //unload listener...
      // didunmount
    };
  }, [newcontentset, id, title]);

  return (
    <div ref={thisComponentRef}>
      {!newcontentset && (
        <div style={{ paddingTop: "15rem", paddingBottom: "15rem" }}>
          <Loading>
            <SharePanel display="none" />
          </Loading>
        </div>
      )}
      {newcontentset && (
        <section>
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
          />
          <SeoComponent
            title={title_clean + " #startupitalia"}
            description={excerpt_clean}
            meta={[
              {
                property: "og:image",
                content: featuredImage ? featuredImage.mediaItemUrl : "",
              },
            ]}
          />
          <article
            data-id={id}
            id={`post-${postId}`}
            className={`post-${postId} page type-page status-publish hentry entry`}
          >
            <header
              className="entry-header"
              style={{ display: hide_header, height: header_height }}
            >
              {/*}<ImgFeatured src={srcImgFeatured}/>*/}
              {/*}<center><h1 className="entry-title">{title}</h1></center>*/}
              <div className="entry-meta" />
              {/* .meta-info */}
            </header>

            <div
              style={{
                position: "absolute",
                top: "50%",
                right: "1%",
                zIndex: "100",
              }}
              className="div-page-edit-button"
            >
              <EditPostButton
                postId={postId || pageId}
                vertical={vertical}
                kind={kind}
              />
            </div>

            <center>
              <div className="entry-page-content">
                {newcontent.indexOf("<banner>") === -1 && (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: newcontent.replace(/(?:\r\n|\r|\n)/g, ""),
                    }}
                  />
                )}
                {newcontent.indexOf("<banner>") > -1 && (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: newcontent
                        .replace(/(?:\r\n|\r|\n)/g, "")
                        .replace(/<banner>.*$/i, ""),
                    }}
                  />
                )}
                {newcontent.indexOf("<banner>") > -1 && <BannerComponent />}
                {newcontent.indexOf("<banner>") > -1 && (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: newcontent
                        .replace(/(?:\r\n|\r|\n)/g, "")
                        .replace(/^.*<\/banner>/i, ""),
                    }}
                  />
                )}
                {[
                  "economy",
                  "education",
                  "impact",
                  "lifestyle",
                  "startup",
                  "tech",
                ].includes(pathnameCleaned) && (
                  <div style={{width: "100%", textAlign: "right", paddingRight: "6rem"}}>
                    <Link
                      to={"/category/" + pathnameCleaned + "/"}
                    >
                      <div>All posts of <b>{pathnameCleaned}</b></div>
                    </Link>
                  </div>
                )}

                {/* <div
                dangerouslySetInnerHTML={{ __html: newcontent.replace(/(?:\r\n|\r|\n)/g, '')}}/> */}
              </div>
            </center>

            {/* .entry-content */}
            <footer className="entry-footer" />
            <div style={{ marginLeft: "30px" }}>
              <SharePanel
                display="none"
                components_name_md5="_page"
                float="none"
              />
            </div>
          </article>
        </section>
      )}
    </div>
  );
}

export default SinglePage
